import { Stack, Typography } from "@mui/material";
import { loginSchema } from "common/utils/schemas";
import { AppForm, AppFormField, SubmitButton } from "components/Molecules/Form";
import { useThemePalette } from "common/hooks/theme_palette";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginRequest } from "services/modules/authenticate";
import Loader from "components/Atoms/SharedComponents/Loader/Loader";
import setAuthToken from "services/modules/utils/handel_api";
import { useTranslation } from "react-i18next";

export default function LoginForm() {
  const { t } = useTranslation();
  const FCMToken = useSelector((state) => state.notifications.FCMToken);

  const { load } = useSelector((state) => state?.authenticate);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orange } = useThemePalette();

  const handleFormSubmit = (values, { setSubmitting }) => {
    const action = (data) => {
      localStorage.setItem("token", data?.extra?.access_token);
      localStorage.setItem("user_type", data?.data?.user_type);
      localStorage.setItem("account_type", data?.data?.user?.account_type);
      localStorage.setItem("firebase_uid", data?.data?.user?.firebase_uid);
      localStorage.setItem("userInfo", JSON.stringify(data?.data?.user));
      window.dispatchEvent(new Event("storage"));
      setAuthToken(data?.extra?.access_token);
      //window.dispatchEvent(new Event("userInfo"));

      // window.location.reload();
    };
    const requestData = {
      body: {
        user: values,
        device: {
          fcm_token: FCMToken || "fcm_token",
          device_type: 1,
        },
      },
      action,
    };
    dispatch(loginRequest(requestData));
    setSubmitting(false);
  };

  return (
    <>
      <Loader open={load?.loading} />
      <Stack sx={{ gap: 4 }}>
        <div>
          <Typography fontFamily="Cairo" fontSize="32px" fontWeight="500">
            {t("auth.login.title")}
          </Typography>
          <Typography fontSize="18" fontWeight="400">
            {t("auth.login.subtitle")}
          </Typography>
        </div>
        {/* <Divider sx={{ border: "1px solid #F5F5F5" }} /> */}

        <AppForm
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={loginSchema}
          onSubmit={(values, { setSubmitting }) => {
            handleFormSubmit(values, { setSubmitting });
          }}
        >
          <Stack sx={{ gap: 2 }}>
            <AppFormField
              label={t("auth.login.email_label")}
              name="email"
              type="text"
              // labelStyle={{ fontSize: "18px" }}
              placeholder={t("auth.login.email_placeholder")}
            />
            <AppFormField
              label={t("auth.login.password_label")}
              name="password"
              // labelStyle={{ fontSize: "18px" }}
              type="password"
              placeholder="***********"
              // sx={{ backgroundColor: "#FBFBFB" }}
            />
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Typography
                sx={{
                  color: orange,
                  cursor: "pointer",
                  fontWeight: "400",
                  fontSize: "18px",
                }}
                onClick={(_) => navigate("/forget-password")}
              >
                {t("auth.login.forget_password")}
              </Typography>
            </Stack>
            <Stack sx={{ mt: 2 }}>
              <SubmitButton>{t("auth.login.submit")}</SubmitButton>
            </Stack>
          </Stack>
        </AppForm>
      </Stack>
    </>
  );
}
